let contador = 0

/** Genera un identificador único y estable para clases, bloques y ejercicios. */
export function nuevoId(prefijo = 'id'): string {
  contador += 1
  const base =
    typeof crypto !== 'undefined' && 'randomUUID' in crypto
      ? crypto.randomUUID().split('-')[0]
      : Math.random().toString(36).slice(2, 10)
  return `${prefijo}_${Date.now().toString(36)}_${base}_${contador}`
}
